import React from "react";
import loader from "../../svg/LandingPageImages/VestnHeaderLogo.svg";

interface LoaderProps {
  message?: string;
  fullScreen?: boolean;
}

const Loader: React.FC<LoaderProps> = ({
  message = "Loading...",
  fullScreen = true,
}) => {
  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-[20000] flex items-center justify-center bg-background px-4">
        <div className="flex flex-col items-center gap-4 sm:gap-5 md:gap-6 lg:gap-7 relative w-full max-w-md">
          {/* Animated VESTN Logo with pulse effect - responsive sizes */}
          <div className="relative z-10">
            {/* Ping effect - responsive */}
            <div className="absolute inset-0 -m-2 sm:-m-3 md:-m-4 lg:-m-5 rounded-full bg-primary/20 animate-ping"></div>
            <div className="relative">
              <img
                src={loader}
                alt="VESTN Loader"
                className="w-24 h-24 sm:w-28 sm:h-28 md:w-36 md:h-36 lg:w-40 lg:h-40 xl:w-44 xl:h-44 2xl:w-48 2xl:h-48 animate-pulse drop-shadow-2xl"
                style={{
                  animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
                }}
              />
            </div>
          </div>

          {/* Loading text with fade animation - responsive */}
          <div className="flex flex-col items-center gap-1.5 sm:gap-2 md:gap-2.5 z-10 w-full px-4">
            <p className="text-foreground text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl font-medium text-center">
              {message}
            </p>
            {/* Animated dots - responsive sizes */}
            <div className="flex gap-1 sm:gap-1.5">
              <span
                className="w-1.5 h-1.5 sm:w-2 sm:h-2 md:w-2.5 md:h-2.5 rounded-full bg-primary animate-bounce"
                style={{ animationDelay: "0ms" }}
              ></span>
              <span
                className="w-1.5 h-1.5 sm:w-2 sm:h-2 md:w-2.5 md:h-2.5 rounded-full bg-primary animate-bounce"
                style={{ animationDelay: "150ms" }}
              ></span>
              <span
                className="w-1.5 h-1.5 sm:w-2 sm:h-2 md:w-2.5 md:h-2.5 rounded-full bg-primary animate-bounce"
                style={{ animationDelay: "300ms" }}
              ></span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Inline loader variant (for non-fullscreen use) - responsive
  return (
    <div className="flex flex-col items-center justify-center gap-3 sm:gap-4 md:gap-5 py-6 sm:py-8 md:py-10">
      <div className="relative">
        <div className="absolute inset-0 -m-2 sm:-m-3 rounded-full bg-primary/10 animate-ping"></div>
        <div className="relative">
          <img
            src={loader}
            alt="VESTN Loader"
            className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 lg:w-32 lg:h-32 animate-pulse"
            style={{
              animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
            }}
          />
        </div>
      </div>
      <p className="text-foreground text-xs sm:text-sm md:text-base font-medium text-center px-4">
        {message}
      </p>
    </div>
  );
};

export default Loader;
